export default function Hero() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      id="hero"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      style={{
        backgroundImage: 'url(https://public.readdy.ai/ai/img_res/702f2aa96b91e47fd620a8891dfe5445.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      <div className="absolute inset-0 bg-white/75"></div>
      <div className="relative z-10 max-w-7xl mx-auto px-6 py-20 w-full">
        <div className="max-w-2xl">
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6 leading-tight">
            <strong>Professional Cleaning Services in Portland, Westbrook & Cumberland</strong>
          </h1>
          <p className="text-xl text-gray-700 mb-8 leading-relaxed">
            Quality <strong>cleaning services</strong> for your home and business. Experienced team, eco-friendly products, and guaranteed satisfaction.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
            <button 
              onClick={() => scrollToSection('reservation')}
              className="bg-teal-600 text-white px-8 py-4 rounded-full hover:bg-teal-700 transition-all duration-300 font-semibold text-lg shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap flex items-center justify-center"
            >
              <i className="ri-calendar-check-line mr-2"></i>
              Book Now
            </button>
            <button 
              onClick={() => scrollToSection('services')}
              className="bg-white text-teal-600 px-8 py-4 rounded-full hover:bg-gray-50 transition-all duration-300 font-semibold text-lg shadow-lg hover:shadow-xl border-2 border-teal-600 cursor-pointer whitespace-nowrap flex items-center justify-center"
            >
              <i className="ri-service-line mr-2"></i>
              Our Services
            </button>
            <a
              href="tel:+12076508754"
              className="inline-flex items-center gap-2 bg-white text-teal-600 px-8 py-4 rounded-full hover:bg-gray-50 transition-all font-semibold text-lg shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-line text-xl"></i>
              (207) 650-8754
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}